<!-- Feather icons section start -->
<section id="simple-line-icons">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Simple Line Icons</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="simple-line-icons overflow-hidden">
              <div class="row">
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-user-female"></i>
                  </div>
                  <label class="fonticon-classname">icon-user-female</label>
                  <label class="fonticon-unit">e000</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-user-follow"></i>
                  </div>
                  <label class="fonticon-classname">icon-user-follow</label>
                  <label class="fonticon-unit">e002</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-user-following"></i>
                  </div>
                  <label class="fonticon-classname">icon-user-following</label>
                  <label class="fonticon-unit">e003</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-user-unfollow"></i>
                  </div>
                  <label class="fonticon-classname">icon-user-unfollow</label>
                  <label class="fonticon-unit">e004</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-trophy"></i>
                  </div>
                  <label class="fonticon-classname">icon-trophy</label>
                  <label class="fonticon-unit">e006</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-screen-smartphone"></i>
                  </div>
                  <label class="fonticon-classname">icon-screen-smartphone</label>
                  <label class="fonticon-unit">e010</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-screen-desktop"></i>
                  </div>
                  <label class="fonticon-classname">icon-screen-desktop</label>
                  <label class="fonticon-unit">e011</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-plane"></i>
                  </div>
                  <label class="fonticon-classname">icon-plane</label>
                  <label class="fonticon-unit">e012</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-notebook"></i>
                  </div>
                  <label class="fonticon-classname">icon-notebook</label>
                  <label class="fonticon-unit">e013</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-moustache"></i>
                  </div>
                  <label class="fonticon-classname">icon-moustache</label>
                  <label class="fonticon-unit">e014</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-mouse"></i>
                  </div>
                  <label class="fonticon-classname">icon-mouse</label>
                  <label class="fonticon-unit">e015</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-magnet"></i>
                  </div>
                  <label class="fonticon-classname">icon-magnet</label>
                  <label class="fonticon-unit">e016</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-energy"></i>
                  </div>
                  <label class="fonticon-classname">icon-energy</label>
                  <label class="fonticon-unit">e020</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-emoticon-smile"></i>
                  </div>
                  <label class="fonticon-classname">icon-emoticon-smile</label>
                  <label class="fonticon-unit">e021</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-disc"></i>
                  </div>
                  <label class="fonticon-classname">icon-disc</label>
                  <label class="fonticon-unit">e022</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-cursor-move"></i>
                  </div>
                  <label class="fonticon-classname">icon-cursor-move</label>
                  <label class="fonticon-unit">e023</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-crop"></i>
                  </div>
                  <label class="fonticon-classname">icon-crop</label>
                  <label class="fonticon-unit">e024</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-credit-card"></i>
                  </div>
                  <label class="fonticon-classname">icon-credit-card</label>
                  <label class="fonticon-unit">e025</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-chemistry"></i>
                  </div>
                  <label class="fonticon-classname">icon-chemistry</label>
                  <label class="fonticon-unit">e026</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-user"></i>
                  </div>
                  <label class="fonticon-classname">icon-user</label>
                  <label class="fonticon-unit">e005</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-speedometer"></i>
                  </div>
                  <label class="fonticon-classname">icon-speedometer</label>
                  <label class="fonticon-unit">e007</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-social-youtube"></i>
                  </div>
                  <label class="fonticon-classname">icon-social-youtube</label>
                  <label class="fonticon-unit">e008</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-social-twitter"></i>
                  </div>
                  <label class="fonticon-classname">icon-social-twitter</label>
                  <label class="fonticon-unit">e009</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-social-tumblr"></i>
                  </div>
                  <label class="fonticon-classname">icon-social-tumblr</label>
                  <label class="fonticon-unit">e00a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-social-facebook"></i>
                  </div>
                  <label class="fonticon-classname">icon-social-facebook</label>
                  <label class="fonticon-unit">e00b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-social-dropbox"></i>
                  </div>
                  <label class="fonticon-classname">icon-social-dropbox</label>
                  <label class="fonticon-unit">e00c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-social-dribbble"></i>
                  </div>
                  <label class="fonticon-classname">icon-social-dribbble</label>
                  <label class="fonticon-unit">e00d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-shield"></i>
                  </div>
                  <label class="fonticon-classname">icon-shield</label>
                  <label class="fonticon-unit">e00e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-screen-tablet"></i>
                  </div>
                  <label class="fonticon-classname">icon-screen-tablet</label>
                  <label class="fonticon-unit">e00f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-magic-wand"></i>
                  </div>
                  <label class="fonticon-classname">icon-magic-wand</label>
                  <label class="fonticon-unit">e017</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-hourglass"></i>
                  </div>
                  <label class="fonticon-classname">icon-hourglass</label>
                  <label class="fonticon-unit">e018</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-graduation"></i>
                  </div>
                  <label class="fonticon-classname">icon-graduation</label>
                  <label class="fonticon-unit">e019</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-ghost"></i>
                  </div>
                  <label class="fonticon-classname">icon-ghost</label>
                  <label class="fonticon-unit">e01a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-game-controller"></i>
                  </div>
                  <label class="fonticon-classname">icon-game-controller</label>
                  <label class="fonticon-unit">e01b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-fire"></i>
                  </div>
                  <label class="fonticon-classname">icon-fire</label>
                  <label class="fonticon-unit">e01c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-eyeglasses"></i>
                  </div>
                  <label class="fonticon-classname">icon-eyeglasses</label>
                  <label class="fonticon-unit">e01d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-envelope-open"></i>
                  </div>
                  <label class="fonticon-classname">icon-envelope-open</label>
                  <label class="fonticon-unit">e01e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-envelope-letter"></i>
                  </div>
                  <label class="fonticon-classname">icon-envelope-letter</label>
                  <label class="fonticon-unit">e01f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-bell"></i>
                  </div>
                  <label class="fonticon-classname">icon-bell</label>
                  <label class="fonticon-unit">e027</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-badge"></i>
                  </div>
                  <label class="fonticon-classname">icon-badge</label>
                  <label class="fonticon-unit">e028</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-anchor"></i>
                  </div>
                  <label class="fonticon-classname">icon-anchor</label>
                  <label class="fonticon-unit">e029</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-wallet"></i>
                  </div>
                  <label class="fonticon-classname">icon-wallet</label>
                  <label class="fonticon-unit">e02a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-vector"></i>
                  </div>
                  <label class="fonticon-classname">icon-vector</label>
                  <label class="fonticon-unit">e02b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-speech"></i>
                  </div>
                  <label class="fonticon-classname">icon-speech</label>
                  <label class="fonticon-unit">e02c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-puzzle"></i>
                  </div>
                  <label class="fonticon-classname">icon-puzzle</label>
                  <label class="fonticon-unit">e02d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-printer"></i>
                  </div>
                  <label class="fonticon-classname">icon-printer</label>
                  <label class="fonticon-unit">e02e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-present"></i>
                  </div>
                  <label class="fonticon-classname">icon-present</label>
                  <label class="fonticon-unit">e02f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-playlist"></i>
                  </div>
                  <label class="fonticon-classname">icon-playlist</label>
                  <label class="fonticon-unit">e030</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-pin"></i>
                  </div>
                  <label class="fonticon-classname">icon-pin</label>
                  <label class="fonticon-unit">e031</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-picture"></i>
                  </div>
                  <label class="fonticon-classname">icon-picture</label>
                  <label class="fonticon-unit">e032</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-map"></i>
                  </div>
                  <label class="fonticon-classname">icon-map</label>
                  <label class="fonticon-unit">e033</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-layers"></i>
                  </div>
                  <label class="fonticon-classname">icon-layers</label>
                  <label class="fonticon-unit">e034</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-handbag"></i>
                  </div>
                  <label class="fonticon-classname">icon-handbag</label>
                  <label class="fonticon-unit">e035</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-globe-alt"></i>
                  </div>
                  <label class="fonticon-classname">icon-globe-alt</label>
                  <label class="fonticon-unit">e036</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-globe"></i>
                  </div>
                  <label class="fonticon-classname">icon-globe</label>
                  <label class="fonticon-unit">e037</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-frame"></i>
                  </div>
                  <label class="fonticon-classname">icon-frame</label>
                  <label class="fonticon-unit">e038</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-folder-alt"></i>
                  </div>
                  <label class="fonticon-classname">icon-folder-alt</label>
                  <label class="fonticon-unit">e039</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-film"></i>
                  </div>
                  <label class="fonticon-classname">icon-film</label>
                  <label class="fonticon-unit">e03a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-feed"></i>
                  </div>
                  <label class="fonticon-classname">icon-feed</label>
                  <label class="fonticon-unit">e03b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-earphones-alt"></i>
                  </div>
                  <label class="fonticon-classname">icon-earphones-alt</label>
                  <label class="fonticon-unit">e03c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-earphones"></i>
                  </div>
                  <label class="fonticon-classname">icon-earphones</label>
                  <label class="fonticon-unit">e03d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-drop"></i>
                  </div>
                  <label class="fonticon-classname">icon-drop</label>
                  <label class="fonticon-unit">e03e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-drawer"></i>
                  </div>
                  <label class="fonticon-classname">icon-drawer</label>
                  <label class="fonticon-unit">e03f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-docs"></i>
                  </div>
                  <label class="fonticon-classname">icon-docs</label>
                  <label class="fonticon-unit">e040</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-directions"></i>
                  </div>
                  <label class="fonticon-classname">icon-directions</label>
                  <label class="fonticon-unit">e041</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-direction"></i>
                  </div>
                  <label class="fonticon-classname">icon-direction</label>
                  <label class="fonticon-unit">e042</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-diamond"></i>
                  </div>
                  <label class="fonticon-classname">icon-diamond</label>
                  <label class="fonticon-unit">e043</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-cup"></i>
                  </div>
                  <label class="fonticon-classname">icon-cup</label>
                  <label class="fonticon-unit">e044</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-compass"></i>
                  </div>
                  <label class="fonticon-classname">icon-compass</label>
                  <label class="fonticon-unit">e045</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-call-out"></i>
                  </div>
                  <label class="fonticon-classname">icon-call-out</label>
                  <label class="fonticon-unit">e046</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-call-in"></i>
                  </div>
                  <label class="fonticon-classname">icon-call-in</label>
                  <label class="fonticon-unit">e047</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-call-end"></i>
                  </div>
                  <label class="fonticon-classname">icon-call-end</label>
                  <label class="fonticon-unit">e048</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-calculator"></i>
                  </div>
                  <label class="fonticon-classname">icon-calculator</label>
                  <label class="fonticon-unit">e049</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-bubbles"></i>
                  </div>
                  <label class="fonticon-classname">icon-bubbles</label>
                  <label class="fonticon-unit">e04a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-briefcase"></i>
                  </div>
                  <label class="fonticon-classname">icon-briefcase</label>
                  <label class="fonticon-unit">e04b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-book-open"></i>
                  </div>
                  <label class="fonticon-classname">icon-book-open</label>
                  <label class="fonticon-unit">e04c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-basket-loaded"></i>
                  </div>
                  <label class="fonticon-classname">icon-basket-loaded</label>
                  <label class="fonticon-unit">e04d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-basket"></i>
                  </div>
                  <label class="fonticon-classname">icon-basket</label>
                  <label class="fonticon-unit">e04e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-bag"></i>
                  </div>
                  <label class="fonticon-classname">icon-bag</label>
                  <label class="fonticon-unit">e04f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-action-undo"></i>
                  </div>
                  <label class="fonticon-classname">icon-action-undo</label>
                  <label class="fonticon-unit">e050</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-action-redo"></i>
                  </div>
                  <label class="fonticon-classname">icon-action-redo</label>
                  <label class="fonticon-unit">e051</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-wrench"></i>
                  </div>
                  <label class="fonticon-classname">icon-wrench</label>
                  <label class="fonticon-unit">e052</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-umbrella"></i>
                  </div>
                  <label class="fonticon-classname">icon-umbrella</label>
                  <label class="fonticon-unit">e053</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-trash"></i>
                  </div>
                  <label class="fonticon-classname">icon-trash</label>
                  <label class="fonticon-unit">e054</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-tag"></i>
                  </div>
                  <label class="fonticon-classname">icon-tag</label>
                  <label class="fonticon-unit">e055</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-support"></i>
                  </div>
                  <label class="fonticon-classname">icon-support</label>
                  <label class="fonticon-unit">e056</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-size-fullscreen"></i>
                  </div>
                  <label class="fonticon-classname">icon-size-fullscreen</label>
                  <label class="fonticon-unit">e057</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-size-actual"></i>
                  </div>
                  <label class="fonticon-classname">icon-size-actual</label>
                  <label class="fonticon-unit">e058</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-shuffle"></i>
                  </div>
                  <label class="fonticon-classname">icon-shuffle</label>
                  <label class="fonticon-unit">e059</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-share-alt"></i>
                  </div>
                  <label class="fonticon-classname">icon-share-alt</label>
                  <label class="fonticon-unit">e05a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-share"></i>
                  </div>
                  <label class="fonticon-classname">icon-share</label>
                  <label class="fonticon-unit">e05b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-rocket"></i>
                  </div>
                  <label class="fonticon-classname">icon-rocket</label>
                  <label class="fonticon-unit">e05c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-question"></i>
                  </div>
                  <label class="fonticon-classname">icon-question</label>
                  <label class="fonticon-unit">e05d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-pie-chart"></i>
                  </div>
                  <label class="fonticon-classname">icon-pie-chart</label>
                  <label class="fonticon-unit">e05e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-pencil"></i>
                  </div>
                  <label class="fonticon-classname">icon-pencil</label>
                  <label class="fonticon-unit">e05f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-note"></i>
                  </div>
                  <label class="fonticon-classname">icon-note</label>
                  <label class="fonticon-unit">e060</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-music-tone-alt"></i>
                  </div>
                  <label class="fonticon-classname">icon-music-tone-alt</label>
                  <label class="fonticon-unit">e061</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-music-tone"></i>
                  </div>
                  <label class="fonticon-classname">icon-music-tone</label>
                  <label class="fonticon-unit">e062</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-microphone"></i>
                  </div>
                  <label class="fonticon-classname">icon-microphone</label>
                  <label class="fonticon-unit">e063</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-loop"></i>
                  </div>
                  <label class="fonticon-classname">icon-loop</label>
                  <label class="fonticon-unit">e064</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-logout"></i>
                  </div>
                  <label class="fonticon-classname">icon-logout</label>
                  <label class="fonticon-unit">e065</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-login"></i>
                  </div>
                  <label class="fonticon-classname">icon-login</label>
                  <label class="fonticon-unit">e066</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-list"></i>
                  </div>
                  <label class="fonticon-classname">icon-list</label>
                  <label class="fonticon-unit">e067</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-like"></i>
                  </div>
                  <label class="fonticon-classname">icon-like</label>
                  <label class="fonticon-unit">e068</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-home"></i>
                  </div>
                  <label class="fonticon-classname">icon-home</label>
                  <label class="fonticon-unit">e069</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-grid"></i>
                  </div>
                  <label class="fonticon-classname">icon-grid</label>
                  <label class="fonticon-unit">e06a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-graph"></i>
                  </div>
                  <label class="fonticon-classname">icon-graph</label>
                  <label class="fonticon-unit">e06b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-equalizer"></i>
                  </div>
                  <label class="fonticon-classname">icon-equalizer</label>
                  <label class="fonticon-unit">e06c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-dislike"></i>
                  </div>
                  <label class="fonticon-classname">icon-dislike</label>
                  <label class="fonticon-unit">e06d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-cursor"></i>
                  </div>
                  <label class="fonticon-classname">icon-cursor</label>
                  <label class="fonticon-unit">e06e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-control-start"></i>
                  </div>
                  <label class="fonticon-classname">icon-control-start</label>
                  <label class="fonticon-unit">e06f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-control-rewind"></i>
                  </div>
                  <label class="fonticon-classname">icon-control-rewind</label>
                  <label class="fonticon-unit">e070</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-control-play"></i>
                  </div>
                  <label class="fonticon-classname">icon-control-play</label>
                  <label class="fonticon-unit">e071</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-control-pause"></i>
                  </div>
                  <label class="fonticon-classname">icon-control-pause</label>
                  <label class="fonticon-unit">e072</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-control-forward"></i>
                  </div>
                  <label class="fonticon-classname">icon-control-forward</label>
                  <label class="fonticon-unit">e073</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-control-end"></i>
                  </div>
                  <label class="fonticon-classname">icon-control-end</label>
                  <label class="fonticon-unit">e074</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-calendar"></i>
                  </div>
                  <label class="fonticon-classname">icon-calendar</label>
                  <label class="fonticon-unit">e075</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-bulb"></i>
                  </div>
                  <label class="fonticon-classname">icon-bulb</label>
                  <label class="fonticon-unit">e076</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-bar-chart"></i>
                  </div>
                  <label class="fonticon-classname">icon-bar-chart</label>
                  <label class="fonticon-unit">e077</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-arrow-up"></i>
                  </div>
                  <label class="fonticon-classname">icon-arrow-up</label>
                  <label class="fonticon-unit">e078</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-arrow-right"></i>
                  </div>
                  <label class="fonticon-classname">icon-arrow-right</label>
                  <label class="fonticon-unit">e079</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-arrow-left"></i>
                  </div>
                  <label class="fonticon-classname">icon-arrow-left</label>
                  <label class="fonticon-unit">e07a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-arrow-down"></i>
                  </div>
                  <label class="fonticon-classname">icon-arrow-down</label>
                  <label class="fonticon-unit">e07b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-ban"></i>
                  </div>
                  <label class="fonticon-classname">icon-ban</label>
                  <label class="fonticon-unit">e07c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-bubble"></i>
                  </div>
                  <label class="fonticon-classname">icon-bubble</label>
                  <label class="fonticon-unit">e07d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-camcorder"></i>
                  </div>
                  <label class="fonticon-classname">icon-camcorder</label>
                  <label class="fonticon-unit">e07e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-camera"></i>
                  </div>
                  <label class="fonticon-classname">icon-camera</label>
                  <label class="fonticon-unit">e07f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-check"></i>
                  </div>
                  <label class="fonticon-classname">icon-check</label>
                  <label class="fonticon-unit">e080</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-clock"></i>
                  </div>
                  <label class="fonticon-classname">icon-clock</label>
                  <label class="fonticon-unit">e081</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-close"></i>
                  </div>
                  <label class="fonticon-classname">icon-close</label>
                  <label class="fonticon-unit">e082</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-cloud-download"></i>
                  </div>
                  <label class="fonticon-classname">icon-cloud-download</label>
                  <label class="fonticon-unit">e083</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-cloud-upload"></i>
                  </div>
                  <label class="fonticon-classname">icon-cloud-upload</label>
                  <label class="fonticon-unit">e084</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-doc"></i>
                  </div>
                  <label class="fonticon-classname">icon-doc</label>
                  <label class="fonticon-unit">e085</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-envelope"></i>
                  </div>
                  <label class="fonticon-classname">icon-envelope</label>
                  <label class="fonticon-unit">e086</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-eye"></i>
                  </div>
                  <label class="fonticon-classname">icon-eye</label>
                  <label class="fonticon-unit">e087</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-flag"></i>
                  </div>
                  <label class="fonticon-classname">icon-flag</label>
                  <label class="fonticon-unit">e088</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-folder"></i>
                  </div>
                  <label class="fonticon-classname">icon-folder</label>
                  <label class="fonticon-unit">e089</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-heart"></i>
                  </div>
                  <label class="fonticon-classname">icon-heart</label>
                  <label class="fonticon-unit">e08a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-info"></i>
                  </div>
                  <label class="fonticon-classname">icon-info</label>
                  <label class="fonticon-unit">e08b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-key"></i>
                  </div>
                  <label class="fonticon-classname">icon-key</label>
                  <label class="fonticon-unit">e08c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-link"></i>
                  </div>
                  <label class="fonticon-classname">icon-link</label>
                  <label class="fonticon-unit">e08d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-lock"></i>
                  </div>
                  <label class="fonticon-classname">icon-lock</label>
                  <label class="fonticon-unit">e08e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-lock-open"></i>
                  </div>
                  <label class="fonticon-classname">icon-lock-open</label>
                  <label class="fonticon-unit">e08f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-magnifier"></i>
                  </div>
                  <label class="fonticon-classname">icon-magnifier</label>
                  <label class="fonticon-unit">e090</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-magnifier-add"></i>
                  </div>
                  <label class="fonticon-classname">icon-magnifier-add</label>
                  <label class="fonticon-unit">e091</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-magnifier-remove"></i>
                  </div>
                  <label class="fonticon-classname">icon-magnifier-remove</label>
                  <label class="fonticon-unit">e092</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-paper-clip"></i>
                  </div>
                  <label class="fonticon-classname">icon-paper-clip</label>
                  <label class="fonticon-unit">e093</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-paper-plane"></i>
                  </div>
                  <label class="fonticon-classname">icon-paper-plane</label>
                  <label class="fonticon-unit">e094</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-plus"></i>
                  </div>
                  <label class="fonticon-classname">icon-plus</label>
                  <label class="fonticon-unit">e095</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-pointer"></i>
                  </div>
                  <label class="fonticon-classname">icon-pointer</label>
                  <label class="fonticon-unit">e096</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-power"></i>
                  </div>
                  <label class="fonticon-classname">icon-power</label>
                  <label class="fonticon-unit">e097</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-refresh"></i>
                  </div>
                  <label class="fonticon-classname">icon-refresh</label>
                  <label class="fonticon-unit">e098</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-reload"></i>
                  </div>
                  <label class="fonticon-classname">icon-reload</label>
                  <label class="fonticon-unit">e099</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-settings"></i>
                  </div>
                  <label class="fonticon-classname">icon-settings</label>
                  <label class="fonticon-unit">e09a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-star"></i>
                  </div>
                  <label class="fonticon-classname">icon-star</label>
                  <label class="fonticon-unit">e09b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-symbol-female"></i>
                  </div>
                  <label class="fonticon-classname">icon-symbol-female</label>
                  <label class="fonticon-unit">e09c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-symbol-male"></i>
                  </div>
                  <label class="fonticon-classname">icon-symbol-male</label>
                  <label class="fonticon-unit">e09d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-target"></i>
                  </div>
                  <label class="fonticon-classname">icon-target</label>
                  <label class="fonticon-unit">e09e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-volume-1"></i>
                  </div>
                  <label class="fonticon-classname">icon-volume-1</label>
                  <label class="fonticon-unit">e09f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-volume-2"></i>
                  </div>
                  <label class="fonticon-classname">icon-volume-2</label>
                  <label class="fonticon-unit">e0a0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-volume-off"></i>
                  </div>
                  <label class="fonticon-classname">icon-volume-off</label>
                  <label class="fonticon-unit">e0a1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="icon-users"></i>
                  </div>
                  <label class="fonticon-classname">icon-users</label>
                  <label class="fonticon-unit">e001</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Feather icons section end -->
